// Pagination
export const QUERY_PARAM_FIRST = 'first';
export const QUERY_PARAM_LAST = 'last';
export const QUERY_PARAM_BEFORE_CURSOR = 'before';
export const QUERY_PARAM_AFTER_CURSOR = 'after';

export const PAGE_SIZE = 12;